<template>
  <div class="margin-subpages">
    <div class="fs-18 fw-700">Happily Logo <span class="opa-04 ml-20 fs-14">Created by HTML/SVG</span></div>
    <div class="contain flex-mid">
      <div class="body-ring flex-mid">
        <div class="body-inner-border flex-mid">
          <div class="inbody-outline flex-mid">
            <div class="inbody flex-mid">
              <div class="inner-shadow flex-mid">
                <div>
                  <div class="mid-container relative">
                    <div class="midle-face center pt-40">
                      <div
                        class="flex-center"
                        style="margin-bottom: 36px; height: 84px"
                      >
                        <div class="eye-container flex-mid mr-auto">
                          <div class="eye-border flex-mid">
                            <div class="eye left-eye"></div>
                          </div>
                        </div>
                        <div class="eye-container flex-mid ml-auto">
                          <div class="eye-border flex-mid">
                            <div class="eye right-eye"></div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          viewBox="0 0 97.37 44.96"
                          version="1.1"
                        >
                          <defs>
                            <linearGradient
                              id="linear-gradient"
                              x1="48.68"
                              x2="48.68"
                              y2="42.75"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop offset="0" stop-color="#fdd93f" />
                              <stop offset="1" stop-color="#f89d01" />
                            </linearGradient>
                            <linearGradient
                              id="linear-gradient-2"
                              x1="48.68"
                              y1="2.15"
                              x2="48.68"
                              y2="40.54"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop offset="0" stop-color="#fae364" />
                              <stop offset="1" stop-color="#facc03" />
                            </linearGradient>
                            <linearGradient
                              id="linear-gradient-3"
                              x1="48.68"
                              y1="2.15"
                              x2="48.68"
                              y2="40.54"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop
                                offset="0"
                                stop-color="#fae364"
                                stop-opacity="0"
                              />
                              <stop
                                offset="0.09"
                                stop-color="#fae160"
                                stop-opacity="0.04"
                              />
                              <stop
                                offset="0.23"
                                stop-color="#fada57"
                                stop-opacity="0.13"
                              />
                              <stop
                                offset="0.41"
                                stop-color="#facf47"
                                stop-opacity="0.29"
                              />
                              <stop
                                offset="0.61"
                                stop-color="#f9c030"
                                stop-opacity="0.52"
                              />
                              <stop
                                offset="0.84"
                                stop-color="#f9ae15"
                                stop-opacity="0.79"
                              />
                              <stop offset="1" stop-color="#f9a000" />
                            </linearGradient>
                          </defs>
                          <g id="Layer_2" data-name="Layer 2">
                            <g id="Layer_1-2" data-name="Layer 1">
                              <path
                                class="cls-1"
                                d="M90.66,2.47A8.82,8.82,0,0,1,96.51,14.8,53,53,0,0,1,48.68,45,53,53,0,0,1,.86,14.8,8.82,8.82,0,0,1,6.71,2.47h0A8.85,8.85,0,0,1,16.83,7.25,35.33,35.33,0,0,0,48.68,27.3a35.33,35.33,0,0,0,31.86-20A8.85,8.85,0,0,1,90.66,2.47Z"
                              />
                              <path
                                class="cls-1"
                                d="M90.66.26a8.82,8.82,0,0,1,5.85,12.33A53,53,0,0,1,48.68,42.75,53,53,0,0,1,.86,12.59,8.82,8.82,0,0,1,6.71.26h0A8.85,8.85,0,0,1,16.83,5.05a35.32,35.32,0,0,0,31.85,20,35.32,35.32,0,0,0,31.86-20A8.85,8.85,0,0,1,90.66.26Z"
                              />
                              <path
                                class="cls-2"
                                d="M90.66.26a8.82,8.82,0,0,1,5.85,12.33A53,53,0,0,1,48.68,42.75,53,53,0,0,1,.86,12.59,8.82,8.82,0,0,1,6.71.26h0A8.85,8.85,0,0,1,16.83,5.05a35.32,35.32,0,0,0,31.85,20,35.32,35.32,0,0,0,31.86-20A8.85,8.85,0,0,1,90.66.26Z"
                              />
                              <path
                                class="cls-3"
                                d="M90.15,2.35a6.61,6.61,0,0,1,4.39,9.24,50.78,50.78,0,0,1-45.86,29A50.76,50.76,0,0,1,2.83,11.59,6.61,6.61,0,0,1,7.22,2.35h0a6.59,6.59,0,0,1,7.56,3.53A37.52,37.52,0,0,0,48.68,27.3,37.52,37.52,0,0,0,82.59,5.88a6.59,6.59,0,0,1,7.56-3.53Z"
                              />
                              <path
                                class="cls-4"
                                d="M90.15,2.35a6.61,6.61,0,0,1,4.39,9.24,50.78,50.78,0,0,1-45.86,29A50.76,50.76,0,0,1,2.83,11.59,6.61,6.61,0,0,1,7.22,2.35h0a6.59,6.59,0,0,1,7.56,3.53A37.52,37.52,0,0,0,48.68,27.3,37.52,37.52,0,0,0,82.59,5.88a6.59,6.59,0,0,1,7.56-3.53Z"
                              />
                              <path
                                class="cls-5"
                                d="M94.37,5.61A7.08,7.08,0,0,0,84.1,8.09,39.38,39.38,0,0,1,48.68,29.51,39.38,39.38,0,0,1,13.27,8.09,6.89,6.89,0,0,0,7.06,4.36a7.49,7.49,0,0,0-1.69.19A7,7,0,0,0,3,5.61,6.58,6.58,0,0,1,7.22,2.35a6.34,6.34,0,0,1,1.61-.2,6.58,6.58,0,0,1,5.95,3.73A37.54,37.54,0,0,0,48.68,27.3,37.55,37.55,0,0,0,82.59,5.88a6.63,6.63,0,0,1,11.78-.27Z"
                              />
                            </g>
                          </g>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "logo",
  data() {
    return {
      iconList: "",
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.cls-1 {
  fill: #a84800;
}
.cls-2 {
  fill: url(#linear-gradient);
}
.cls-3 {
  fill: url(#linear-gradient-2);
}
.cls-4 {
  fill: url(#linear-gradient-3);
}
.cls-5 {
  fill: #fef69b;
}
@keyframes eyes-border-closed {
  0% {
    margin-top: 0px;
    height: 86px;
  }
  5% {
    margin-top: 30px;
    height: 26px;
  }
  10% {
    margin-top: 0px;
    height: 86px;
  }
  100% {
    height: 86px;
  }
}
@keyframes eyes-closed {
  0% {
    height: 80px;
  }
  5% {
    height: 20px;
  }
  10% {
    height: 80px;
  }
  100% {
    height: 80px;
  }
}
.contain {
  width: 512px;
  height: 512px;
  border-radius: 512px;
  margin: 40px auto 40px;
  background: linear-gradient(to top, #633a02, #f9962b);
  .body-ring {
    width: 504px;
    height: 504px;
    border-radius: 504px;
    background: linear-gradient(to top, #f68d0d, #efca2c);
    box-shadow: inset 0px 10px 0 #fcf49b;
    .body-inner-border {
      width: 390px;
      height: 390px;
      border-radius: 390px;
      background: linear-gradient(to top, #fbe179, #da8f1c);
      .inbody-outline {
        width: 382px;
        height: 382px;
        border-radius: 382px;
        background: linear-gradient(to top, #754403, #8b5b1a);
        .inbody {
          width: 374px;
          height: 374px;
          border-radius: 374px;
          background: #f6b628;
          .inner-shadow {
            width: 300px;
            height: 300px;
            border-radius: 300px;
            background-color: transparent;
            box-shadow: 0px -20px 30px #ffffff50, 5px -10px 40px #f6b628,
              -5px -10px 40px #f6b628, inset 0px -10px 20px #f6b628,
              inset 0px -10px 150px #f6b628, inset 0px 10px 30px #ffffff99,
              inset 0px 10px 50px #ffffff90;
            .mid-container {
              .midle-face {
                width: 240px;
                .eye-container {
                  .eye-border {
                    box-shadow: 0 0 7px #000000;
                    animation: eyes-border-closed 6s infinite;
                    width: 46px;
                    height: 86px;
                    border-radius: 46px;
                    background: linear-gradient(to top, #f7850c, #f8e063);
                    .eye {
                      animation: eyes-closed 6s infinite;
                      width: 40px;
                      height: 80px;
                      border-radius: 40px;
                      box-shadow: inset 0px 6px 0 #fff8aa;
                      background: linear-gradient(
                        to top,
                        #f5a022,
                        rgb(238, 201, 51),
                        #ffe26d,
                        #fbe179
                      );
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>